import React, { useEffect, useState } from 'react'
import { ControlProvider } from 'Contexts/ControlContext'
import { useStudio } from 'Contexts/StudioContext'
import { ViolationLevel } from 'shared/violations/types'
import { SupportedPluginsKeyType } from 'Core/PluginCore/PluginsManager'

export type ValidatorRule = {
    type: 'required' | 'email' | 'url' | 'pattern' | 'custom'
    message: string
    pattern?: RegExp
    validator?: (rule: ValidatorRule['type'], value: string | string[] | number) => Promise<void>
}

export type ControlledInputProps = {
    id: string
    type: string
    allowedPlugins?: SupportedPluginsKeyType[]
    rules?: ValidatorRule[]
}

export const ControlledInput: React.FC<React.PropsWithChildren<ControlledInputProps>> = (
    props: React.PropsWithChildren<ControlledInputProps>
) => {
    const studio = useStudio()
    const [isRegistered, setIsRegistered] = useState(false)

    useEffect(() => {
        if (studio) {
            studio.inputManager.registerInput(props.id, {
                ...props,
                addViolation: violation => {
                    studio.inputManager.addViolation(violation)
                },
                removeViolation: (id: string, level?: ViolationLevel) =>
                    studio.inputManager.removeViolation(id, level),
            })
            setIsRegistered(true)
        }
    }, [props, studio])

    return (
        <ControlProvider
            value={{
                addInputRef: ref => studio?.inputManager?.addInputRef(props.id, ref),
                id: props.id,
                updateControlValue: value =>
                    studio?.inputManager?.updateControlValue(props.id, value),
                isRegistered,
            }}
        >
            {props.children}
        </ControlProvider>
    )
}
